export const validateAgentsWorkloadForm = (values) => {
    const errors = {};
    if (!values) {
        return errors;
    }
    if (values.loadLimits) {
        //email
        if (values.loadLimits.email < 1 || values.loadLimits.email > 30) {
            errors.loadLimits = { email: 'Select a number between 1 and 30' };
        }
        //voicemail
        if (values.loadLimits.voicemail < 1 || values.loadLimits.voicemail > 30) {
            errors.loadLimits = { voicemail: 'Select a number between 1 and 30' };
        }
        //chat
        if (values.loadLimits.chat < 1 || values.loadLimits.chat > 30) {
            errors.loadLimits = { chat: 'Select a number between 1 and 30' };
        }
        //messaging, including facebook messenger and whatsapp
        if (values.loadLimits.messaging < 1 || values.loadLimits.messaging > 30) {
            errors.loadLimits = {
                messaging: 'Select a number between 1 and 30',
            };
        }
    }
    return errors;
};
